<template>
    <textarea 
        :class="{
            'border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full': variant === 'default',
            'border-red-500 bg-red-100': hasError,
        }"
        :value="modelValue" 
        :required="required"
        @input="$emit('update:modelValue', $event.target.value)" 
        ref="input"
    ></textarea>
</template>

<script>
    export default {
        props: {
            modelValue: {
                type: [String, Number],
                default: '',
            },
            required: {
                type: Boolean,
                default: false,
            },
            hasError: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: 'default',
            },
        },

        emits: ['update:modelValue'],

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>